/**
 * Cloud implementation of the shared RoleApi contract.
 *
 * For roles the cloud backend exposes the same `/roles` endpoints as local (not
 * node-scoped), so this adapter simply delegates to the existing roleService.
 * Other domains (cameras, groups, ...) will bind the selected nodeId here instead.
 */
import type { RoleApi } from '@trinetra/shared';
import { roleService } from '../services/role.service';

export const cloudRoleApi: RoleApi = {
  list: () => roleService.list(),
  get: (id) => roleService.get(id),
  create: (data) => roleService.create(data),
  update: (id, data) => roleService.update(id, data),
  delete: (id) => roleService.delete(id),
  getPermissions: () => roleService.getPermissions(),
};
